import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AutoLoginPartialRoutesGuard, OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of, switchMap } from 'rxjs';

@Injectable()
/**
 * Enforces support-user first authentication, then falls back to the default authentication
 * applied by the 'AutoLoginPartialRoutesGuard'. (Extends or decorates the (default) AutoLoginPartialRoutesGuard)
 */
export class SupportFirstDashboardGuard implements CanActivate {

  constructor(private oidcSecurityService: OidcSecurityService, private autoLoginPartialRoutesGuard: AutoLoginPartialRoutesGuard) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const result$ = this.oidcSecurityService.isAuthenticated$.pipe(
      switchMap(ar => {
        const supportDbUi = ar.allConfigsAuthenticated.find(r => r.configId === 'dashboard-support-ui');
        if(supportDbUi?.isAuthenticated) {
          return of(true);
        };
        return this.autoLoginPartialRoutesGuard.canActivate(route, state);
      }));

    return result$;
  }
}
